import { get, post } from 'store/http/httpAction';
import { notification } from 'antd';
import {
  SET_RAW_DATA,
  SET_GENERATE_STATE,
  CLEAR_GENERATE_STATE
} from './actionTypes';

const errorNotice = msg => (
  notification.error({
    message: msg,
    duration: 15
  })
);

const setGenerateState = () => ({
  type: SET_GENERATE_STATE
});

export const clearGenerateState = () => ({
  type: CLEAR_GENERATE_STATE
});

export const tryGenerateReportById = reportId => dispatch =>
  post(`/admin/report/${reportId}/generate`, {}, dispatch).then(data => {
    dispatch(setGenerateState());
  });

const setRawData = rawData => ({
  type: SET_RAW_DATA,
  payload: { rawData }
});

export const tryFetchRawDataById = reportId => dispatch =>
  get(`/admin/report/${reportId}/view`, {}, dispatch).then(data => {
    if (data && data.data) {
      dispatch(setRawData(data));
    } else {
      dispatch(clearGenerateState());
      if (data.error) {
        errorNotice(data.error);
      }
    }
  }).catch(() => {
    dispatch(clearGenerateState());
    errorNotice('Please reset your report');
  });



// WEBPACK FOOTER //
// ./src/views/RealTimeReport_Table/flow/actions.js